module.exports = "<div class=\"main-logo-holder\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/product-select/product-select.component.html
// module id = ./src/app/core/components/product-select/product-select.component.html
// module chunks = main